<div class="w-full">
    <div class="bg-card shadow rounded-2xl p-5 m-4">

        <div class="text-2xl text-center font-medium tracking-tight leading-6 mb-8 truncate">
            Corrective Maintenance
        </div>


        <div role="tablist" class="tabs tabs-boxed w-2/4 mt-2 mb-4">
            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': router.url.includes('baseline')}" (click)="toggleMawop('baseline')">
                CM Baseline
            </a>
            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': router.url.includes('emerging')}" (click)="toggleMawop('emerging')">
                CM Emerging
            </a>
            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': router.url.includes('general')}" (click)="toggleMawop('general')">
                General
            </a>
            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': router.url.includes('failure-notification')}" (click)="toggleMawop('failure-notification')">
                Failure Notification
            </a>
        </div>

        <router-outlet></router-outlet>
    </div>
</div>